import { useAppUI } from "providers/ui"

import { Navigation } from "../components/domains/navigation"

export const AppNavigation = (props) => {
  const { sideMenus, mainMenus, matchedPath } = useAppUI()

  return (
    <Navigation
      value={matchedPath?.to}
      bottomNavigations={mainMenus}
      navigations={sideMenus}
      {...props}
    />
  )
}
